export { default } from '@material-ui/core/Popover';

export type PopoverProps = import('@material-ui/core/Popover').PopoverProps;
